module.exports = __webpack_public_path__ + "assets/graph-min.fc2321139faa0e6969d5786c796e7638.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./public/img/Aplifit/graph-min.jpg
 ** module id = 392
 ** module chunks = 0
 **/